module.exports = __webpack_public_path__ + "img/IMG_1039_L_Black_MockedUp.b6ad5e7c.jpg";